module.exports = __webpack_public_path__ + "media/images/emblems/Lalden-coat_of_arms-3639ec3a8dd77d82f44a3ae45d43ee98.svg";